import React from "react"
import styles from "./style.module.css"
interface ModalProps {
    openModal?: boolean;
    closeModal?: () => void;
    header?: string;
    paragraph?: string;
}
const Modal : React.FC<ModalProps> = ({ openModal = false, closeModal, header, paragraph}) => {
    return (
        <>
        {openModal && (
            <div className={styles.overlay}>
                <div className={styles.modal}>
                    <div className={styles.modalContent}>
                        {/* <span className={styles.close} onClick={closeModal}>&times;</span> */}
                        <div className={styles.container}>
                         <h1>{header}</h1>
                         <p>{paragraph}</p>
                         <button onClick={closeModal}>Okay</button>
                        </div>
                    </div>
                </div>
            </div>
        )}
        </>
    )
}

export default Modal;